import { getLocale } from '@ynap/cart-state'

export function suspend() {
    return new Promise(() => {})
}

export function injectScript(src) {
    const script = document.createElement('script')
    script.src = src
    script.async = true
    document.body.appendChild(script)
}

export function injectAndSubmitForm(method, path, params = {}) {
    const form = document.createElement('form')
    form.method = method
    form.action = path

    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const hiddenField = document.createElement('input')
            hiddenField.type = 'hidden'
            hiddenField.name = key
            if (params[key]) {
                hiddenField.value = params[key]
            }

            form.appendChild(hiddenField)
        }
    }

    document.body.appendChild(form)
    form.submit()
}

export const getAdditionalCheckoutHeaders = (state) => {
    const { country } = getLocale(state)
    const { deviceType, config } = state
    
    const { head: { applePay3P }} = config

    const applePay3PEnabled = !!(applePay3P?.enabled && (applePay3P?.enabledIn ? applePay3P.enabledIn.includes(country) : true))

    return !deviceType ? { 'x-multipleMerchantIds': applePay3PEnabled?.toString() } : {}
}